import { CheckIcon } from "@heroicons/react/20/solid";
import { Button } from "@/components/button";
import { routes } from "@/lib/routes";

const NEXT_STEPS = [
  "The practitioner will review your message, background context, and requested session format.",
  "You will receive a response via your provided email address or phone.",
  "If this is an urgent mental health situation, please contact emergency care or call our Navigator.",
];

type InquirySentConfirmationProps = {
  practitionerName?: string;
};

export function InquirySentConfirmation({ practitionerName }: InquirySentConfirmationProps) {
  return (
    <div className="min-h-dvh bg-background-grey pt-(--public-header-height)">
      <div className="page-width flex min-h-[calc(100dvh-var(--public-header-height))] flex-col items-center justify-center py-32">
        <div className="flex w-full max-w-680 flex-col items-center gap-32 rounded-large bg-neutral-white p-24 shadow-[0px_12px_16px_rgba(10,14,20,0.05)] lg:p-64">
          <div className="flex size-96 items-center justify-center rounded-circle bg-tone-aqua-tint">
            <div className="flex size-64 items-center justify-center rounded-circle bg-brand-blue">
              <CheckIcon aria-hidden className="size-32 text-neutral-white" />
            </div>
          </div>

          <div className="flex flex-col items-center gap-16 text-center">
            <h1 className="text-28 leading-[1.3] font-semibold text-brand-dark-blue lg:text-32">
              {practitionerName ? `Your inquiry is on its way to ${practitionerName}` : "Your inquiry is on its way"}
            </h1>
            <p className="text-16 leading-[1.4] text-neutral-black/70 lg:text-18">
              {"We'll send you a confirmation email. Please check your inbox. "}
              {practitionerName
                ? `Your message goes directly to ${practitionerName}. `
                : "Your message goes directly to the practitioner. "}
              {"CMW doesn't read inquiry contents."}
            </p>
          </div>

          <div className="flex w-full flex-col gap-16 rounded-regular border border-neutral-light-grey bg-brand-blue/5 p-16 lg:p-24">
            <p className="text-14 font-semibold text-brand-dark-blue lg:text-16">What happens next?</p>
            {NEXT_STEPS.map((step, index) => (
              <div key={step} className="flex items-start gap-12">
                <p className="shrink-0 text-14 font-semibold text-brand-blue lg:text-16">{index + 1}.</p>
                <p className="text-14 text-neutral-black/70 lg:text-16">{step}</p>
              </div>
            ))}
          </div>

          <Button href={routes.home.url} size="l" className="w-full md:w-auto">
            Return to Directory
          </Button>
        </div>
      </div>
    </div>
  );
}
